import { UserOwnerType } from '../../../store';

export class UserSelectionItem {
  id: number;
  organizationId: number;
  firstName: string;
  lastName: string;
  email: string;
  country: string;
  type: UserOwnerType;
  carrierBoUserPermissions: {
    dockAllocationAllowed: boolean;
    forceDockAllocation: boolean;
    calendarBasedUliAllocationAllowed: boolean;
  };
  userOwners: CompartmentUserOwner;

  constructor(params?: UserSelectionItem) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class CompartmentUserOwner {
  id: number;
  shortName: string;
  longName: string;
  extId: string;
}
